import React from "react";
import { createStyles, makeStyles, Theme, Typography } from "@material-ui/core";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    infoBody: {
      margin: "0.5rem",
    },
    infoSubtitle: {
      fontSize: "1rem",
      fontWeight: "bold",
    },
    infoContent: {
      margin: "1rem",
      fontSize: "0.875rem",
    },
    infoCode: {
      padding: "1rem",
      fontFamily: "Monospace",
      color: "#f8f8f2",
      backgroundColor: "#272c34",
    },
  })
);

/** 辞書設定Info画面(同義語)コンポーネント */
export function DictionaryConfigInfoSynonym() {
  const classes = useStyles();

  //--------------------
  // コンポーネント
  return (
    <>
      <div className={classes.infoBody}>
        <Typography variant="h6" className={classes.infoSubtitle}>
          フォーマット
        </Typography>
        <div className={classes.infoContent}>
          <Typography variant="body1" className={classes.infoCode}>
            {"<テキスト 1>,<テキスト 2>, ... ,<テキスト N>"}
          </Typography>
        </div>
        <Typography variant="h6" className={classes.infoSubtitle}>
          記載例
        </Typography>
        <div className={classes.infoContent}>
          <Typography variant="body1" className={classes.infoCode}>
            エタノール,エチルアルコール
          </Typography>
        </div>
        <Typography variant="h6" className={classes.infoSubtitle}>
          文字コード
        </Typography>
        <div className={classes.infoContent}>
          <Typography variant="body1">UTF-8</Typography>
        </div>
      </div>
    </>
  );
}
